const en = {
  // Nav
  nav: {
    home: 'Home',
    menu: 'Menu',
    order: 'Order',
    gallery: 'Gallery',
    reviews: 'Reviews',
    reservation: 'Reservation',
    reserve: 'Book a table',
  },

  // Home page
  home: {
    sectionCuisine: 'Our cuisine',
    sectionAtmosphere: 'Atmosphere',
    sectionFormules: 'Our set menus',
    sectionActus: 'News',
    sectionSocial: 'Follow us',
    sectionExceptions: 'Exceptional hours',
    formulesSubtitle: 'Great value for your money',
    actusSubtitle: 'What\'s new?',
    seeGallery: 'View the photo gallery',
    seeFullMenu: 'See the full menu',
    googleRating: '4.1/5 on Google',
    googleRatingValue: '4.1',
    googleReviewsCount: '150 reviews',
    formulesFrom: 'Set menus from EUR15',
    closed: 'Closed',
    burgersCount: 'burgers to choose from',
    callUs: 'Call us',
    directions: 'Directions',

    defaultHeroTitle: 'Your neighbourhood restaurant in Bordeaux',
    defaultHeroSubtitle: 'Simple and generous cuisine, shaded terrace, friendly atmosphere.',
    defaultAboutTitle: 'Simple, fresh and generous',
    defaultAboutText: 'At Cote Terrasse, we prepare sincere cuisine using fresh, seasonal produce.',
    defaultAtmosphereTitle: 'A garden-side terrace',
    defaultAtmosphereText: 'Enjoy our garden-side dining room, a true haven of peace in the heart of Bordeaux.',
    defaultCtaTitle: 'Fancy a visit?',
    defaultCtaText: 'Book your table in a few clicks or come see us directly.',
    defaultBtnReserve: 'Book a table',
    defaultBtnMenu: 'See the menu',
    defaultBtnCall: 'Call us',
    defaultBtnDirections: 'Directions',
  },

  // Reservation
  reservation: {
    sectionLabel: 'Reservation & Contact',
    titleOnline: 'Book your table',
    titlePhone: 'Reserve by phone',
    phoneOnly: 'Phone reservation only',
    phoneDesc: 'To book a table, call us directly. Our team will be happy to welcome you.',
    callNow: 'Call now',
    noPhone: 'Phone number not set. Please contact the administrator.',
    formTitle: 'Reservation request',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    date: 'Date',
    time: 'Time',
    guests: 'Guests',
    guestSingular: 'guest',
    guestPlural: 'guests',
    message: 'Message (optional)',
    messagePlaceholder: 'Allergies, special requests...',
    choose: 'Choose',
    namePlaceholder: 'Your name',
    phonePlaceholder: '+33 6 ...',
    emailPlaceholder: 'your@email.com',
    submit: 'Send request',
    sending: 'Sending...',
    success: 'Reservation request sent! We will contact you shortly.',
    errorDate: 'Please select a date',
    errorTime: 'Please select a time',
    errorGeneric: 'An error occurred. Please try again.',
    infoTitle: 'Practical information',
    openingHours: 'Opening hours',
    closed: 'Closed',
  },

  // Gallery
  gallery: {
    sectionLabel: 'Gallery',
    title: 'In pictures',
    description: 'Discover our terrace, our garden-side dining room and our dishes in photos.',
    all: 'All',
    plats: 'Dishes',
    terrasse: 'Terrace',
    salle: 'Dining room',
    ambiance: 'Ambiance',
    empty: 'No photos in this category.',
    lightboxTitle: 'Gallery photo',
  },

  // Menu
  menu: {
    sectionLabel: 'Our menu',
    title: 'The Menu',
    description: 'Discover our homemade burgers, sharing tapas, and great value set menus. Cuisine prepared with fresh, seasonal produce.',
    formules: 'Set Menus',
    supplements: 'Add-ons:',
    from: 'from',
    sides: 'Sides',
    sidesIncluded: 'Included with every burger:',
    sidesIncludedText: 'Fresh fries or seasonal salad.',
    sidesSupplements: 'Add-ons:',
    sidesSupplementsText: 'Sweet potato fries +EUR3 | Bacon +EUR3 | Cheddar +EUR2',
    sidesNote: 'ANGUS Steak 100% Pure Beef French Origin 150g — Fresh Fries cooked Belgian-style in Beef Tallow — Duck Breast from South-West France',
  },

  // Reviews
  reviews: {
    sectionLabel: 'Customer reviews',
    title: 'What they think',
    description: 'Mostly 4 and 5-star reviews. Our customers appreciate the quality of our cuisine, reasonable prices and friendly atmosphere.',
    outOf: 'Based on 200+ reviews',
  },

  // Legal
  legal: {
    title: 'Legal notice',
    editor: 'Site publisher',
    hosting: 'Hosting',
    ip: 'Intellectual property',
    ipText: 'All content on this site (text, images, logos, photos) is the exclusive property of Cote Terrasse, unless otherwise stated. Any reproduction, even partial, is prohibited without prior authorisation.',
    data: 'Personal data',
    dataText: 'Information collected via the reservation form (name, email, phone) is used solely for processing your reservation request. Under the GDPR, you have the right to access, rectify and delete your personal data.',
    cookies: 'Cookies',
    cookiesText: 'This site uses only technical cookies necessary for its operation. No advertising or tracking cookies are used.',
    privacy: 'Privacy policy',
    privacyText: 'We are committed to protecting your privacy. Personal data you provide is never shared with third parties. It is kept for a maximum of 12 months.',
    responsibility: 'Disclaimer',
    responsibilityText: 'Cote Terrasse strives to provide information as accurate as possible. Prices and hours shown are subject to change without notice.',
    publishedBy: 'Publishing director',
    phone: 'Phone',
  },

  // Footer
  footer: {
    description: 'Friendly restaurant in Bordeaux. Seasonal cuisine, homemade burgers and a lovely garden-side terrace.',
    navigation: 'Navigation',
    contact: 'Contact',
    ourMenu: 'Our Menu',
    customerReviews: 'Customer Reviews',
    legalNotice: 'Legal notice',
    legalAndPrivacy: 'Legal notice & Privacy policy',
    admin: 'Administration',
    copyright: 'All rights reserved.',
    defaultAccessTram: 'Access: Tram A (nearby stop)',
    defaultAccessBus: 'Bus 9 (nearby stop)',
    allergenNotice: 'Net prices in Euros including VAT. In accordance with Decree No. 2015-447, allergen information for our dishes is available on request from our staff.',
  },

  // Maintenance
  maintenance: {
    comingSoon: 'We\'ll be back soon',
    defaultMessage: 'Our website is currently being updated. Thank you for your patience.',
    openingHours: 'Opening hours',
    closed: 'Closed',
    copyright: 'All rights reserved.',
  },

  // Common
  common: {
    closed: 'Closed',
    loading: 'Loading...',
  },
};

export default en;
